import { hasProgressiveChars, isSuccessStatus } from "utils/functions/validations"
import { invalidPasswordFields, invalidUserFields, validPasswordFields, validUserFields } from "./subscriptionTypes"
import { IResponseGeneric } from "services/IApi"

export const validateLength = (value, minValue, maxValue?, mustBeAlphanumeric = false): boolean => {
  const maximumValue = 250
  let isValid = !!(value.length >= minValue && value.length <= (maxValue || maximumValue))
  //
  if (mustBeAlphanumeric) {
    const hasOneNumber = /[\d]/.test(value)
    const hasOneLetter = /[a-zñA-ZÑ]/i.test(value)
    isValid = isValid && hasOneNumber && hasOneLetter
  }
  return isValid
}

export const showErrorMessage = (handleFieldError, errorFieldPasswordAge: string) => {
  const event = {
    target: {
      name: 'input',
      value: '',
    },
  }
  handleFieldError(event, { message: errorFieldPasswordAge, isInvalid: true })
}

/// Validates

export const validateSpecialChars = (value) => {
  const isValid = /[^a-z0-9ñÑ ]/gi.test(value)
  return !isValid ? validUserFields.specialChars : invalidUserFields.specialChars
}


const hasOneNumberOrAllowedSpecialChar = (value):boolean => /^(?=.*[!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~ 0-9]).*$/.test(value)
const hasOnlyAllowedChar = (value):boolean => /^[a-zA-Z0-9ñÑ!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~ ]+$/gi.test(value)

export const validateOneNumberSpecialChar = (value) => {
    const isValid = hasOneNumberOrAllowedSpecialChar(value) && hasOnlyAllowedChar(value)
    return  isValid ? validPasswordFields.leastOneSpecialChar : invalidPasswordFields.leastOneSpecialChar
}

export const validateConsecutiveChars = (value) => {
  const isValid = /(.)\1{2,}/.test(value)
  return !isValid ? validPasswordFields.consecutiveChars : invalidPasswordFields.consecutiveChars
}

export const validateOneUpperLowerCaseChars = (value) => {
  const isValid = /^(?=.*[a-zñ])(?=.*[A-ZÑ]).+$/.test(value)
  return isValid ? validPasswordFields.leastOneUpperLowerCaseChars : invalidPasswordFields.leastOneUpperLowerCaseChars
}

export const validateProgressiveChars = (value) => {
  const isValid = hasProgressiveChars(value)
  return !isValid ? validPasswordFields.progressiveChars : invalidPasswordFields.progressiveChars
}
 
export const validateUserDifferentToKey = (value, user) => {
  const userConstSplit = user?.toLowerCase().split(' ')
  const containsUser = userConstSplit.find(item => value.toLowerCase().includes(item.toLowerCase()))
  return !containsUser ? validPasswordFields.userDifferentToKey : invalidPasswordFields.userDifferentToKey
}

export const validatePersonalData = (value, name, documentForeign, lastName, company, collaboratorName, collaboratorLastName, type, isAdminFlow) => {
  const nameConstSplit = name?.toLowerCase().split(' ')
  const containsName = nameConstSplit.find(item => value.toLowerCase().includes(item.toLowerCase()))
  const documentForeignSplit = documentForeign?.toLowerCase().split(' ')
  const containsDocumentForeign = documentForeignSplit.find(item => value.toLowerCase().includes(item.toLowerCase()))
  const lastNameConstSplit = lastName?.toLowerCase().split(' ')
  const containsLastName = lastNameConstSplit.find(item => value.toLowerCase().includes(item.toLowerCase()))
  //
  const companyConstSplit = company?.toLowerCase().split(' ')
  const containsCompany = companyConstSplit.find(item => value.toLowerCase().includes(item.toLowerCase()))
  const containsCollaboratorName = value.toLowerCase().includes(collaboratorName?.toLowerCase())
  const containsCollaboratorLastName = value.toLowerCase().includes(collaboratorLastName?.toLowerCase())
  let isValid
  if (type === 'password') {
    isValid = containsName || containsLastName || containsDocumentForeign
    if (isAdminFlow) {
      isValid = containsCollaboratorName || containsCollaboratorLastName || containsCompany
    }
  }
  return !isValid ? validPasswordFields.personalData : invalidPasswordFields.personalData 
}
 

//////

export const generateFile = (res: IResponseGeneric) => {
    if (isSuccessStatus(res.status)) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.zip')
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    }
  }
